import { FC } from 'react';

import { CustomerListResponseOutputItemsItem } from '@/api/generated';
import { CustomersTableBody } from '@/components/blocks/customers/customers-table-body';
import { CustomersTableHeader } from '@/components/blocks/customers/customers-table-header';
import { Table } from '@/components/ui/table';
import { cn } from '@/lib/utils';

interface CustomersTableProps {
  className?: string;
  filteredCustomers: Array<CustomerListResponseOutputItemsItem>;
  customers: Array<CustomerListResponseOutputItemsItem>;
  handleSelectCustomer: (customerId: number) => Promise<void>;
}

export const CustomersTable: FC<CustomersTableProps> = ({
  className,
  ...customersTableProps
}: CustomersTableProps) => (
  <Table
    className={cn(
      'text-left [&_td:first-child]:pl-4 [&_td:last-child]:pr-4 [&_th:first-child]:pl-4 [&_th:last-child]:pr-4',
      className
    )}>
    <CustomersTableHeader />
    <CustomersTableBody {...customersTableProps} />
  </Table>
);
